import { IResourceSelectorFactory } from 'features/pi/model/resources/IResourceSelectorFactory';
import { IResourceReactRenderer } from 'features/pi/view/resource/IResourceReactRenderer';
import { ImageResourceRenderer } from 'features/pi/view/resource/ImageResourceRenderer';

export interface IResourceReactRendererFactory
    extends IResourceSelectorFactory<IResourceReactRenderer> {}

export class ResourceReactRendererFactory implements IResourceReactRendererFactory {
    getImg(): IResourceReactRenderer<string> {
        return new ImageResourceRenderer();
    }
}
